export default (showAgentCoachings, customFilters) => {
  let resultQuery = '&Filter=';

  const map = {
    statusId: 'status/id',
    reasonId: 'reason/id',
    targetKpiId: 'targetkpi/id',
    agentFirstName: 'salesAgent/firstName',
    agentLastName: 'salesAgent/lastName',
    createdBy: 'originateTeamLead/fullName',
  };

  if (customFilters && customFilters.length) {
    customFilters.forEach((item, i) => {
      if (item.PropertyName.length && item.Value.length) {
        const name = Object.keys(map).includes(item.PropertyName) ? map[item.PropertyName] : item.PropertyName;
        const value = item.Value;
        let substring = '';

        substring = item.Operation === 'Contains' ? `substringof('${value}', ${name})` : `${name} eq ${value}`;
        if (i !== 0) substring = ` and ${substring}`;
        
        resultQuery += substring;
      }
    })
  }

  //add form type filter at end
  resultQuery += `${resultQuery.endsWith('Filter=') ? '' : ' and'} coachingformtype/id ${showAgentCoachings ? 'eq' : 'ne'} 1`;

  return resultQuery;
};


// WEBPACK FOOTER //
// ./src/features/agent-coaching/getCustomQueryParams.js